import { api } from './client'
import type { UserOut, UserWorkload } from '@/types'

export type UserPick = Pick<UserOut, 'id' | 'full_name' | 'role' | 'is_active'>

export interface UserCreate {
  email: string
  role: 'director' | 'deputy_director' | 'chief_engineer' | 'designer'
}

export interface UserPatch {
  full_name?: string
  role?: string
  is_active?: boolean
}

export const usersApi = {
  list: () => api.get<UserOut[]>('/users'),
  /** Активные пользователи для выпадающих списков; доступно и ГИПу (в отличие от list). */
  assignable: () => api.get<UserPick[]>('/users/assignable'),
  listDeleted: () => api.get<UserOut[]>('/users?deleted=true'),
  create: (data: UserCreate) => api.post<UserOut>('/users', data),
  patch: (id: string, data: UserPatch) => api.patch<UserOut>(`/users/${id}`, data),
  resendInvite: (id: string) => api.post(`/users/${id}/resend-invite`),
  /** Мягкое удаление — перемещение в корзину. */
  remove: (id: string) => api.delete(`/users/${id}`),
  /** Восстановление из корзины — снова активен, новое письмо-приглашение. */
  restore: (id: string) => api.post<UserOut>(`/users/${id}/restore`),
  /** Безвозвратное удаление из БД. */
  hardDelete: (id: string) => api.delete(`/users/${id}/permanent`),
  workload: (id: string) => api.get<UserWorkload>(`/users/${id}/workload`),
}
